export default __webpack_public_path__ + "assets/fullscreen_enable.c98b7224.svg";